const CHECKOUT_OPTION = Object.freeze({
  slick: 'slick-pay',
  terminal: 'use-terminal',
  cash: 'cash-pay',
});

// noinspection JSUnusedGlobalSymbols
export default CHECKOUT_OPTION;
